import { render, staticRenderFns } from "./ColouredValueTotalTime.vue?vue&type=template&id=6401a18a&scoped=true&"
import script from "./ColouredValueTotalTime.vue?vue&type=script&lang=js&"
export * from "./ColouredValueTotalTime.vue?vue&type=script&lang=js&"
import style0 from "./ColouredValueTotalTime.vue?vue&type=style&index=0&id=6401a18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401a18a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
